import request from "@/utils/request.js";

// 布控管理列表
export const infopage = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/mg_disposition/info/page",
    method: "post",
    data: data
  });
};
// 布控管理布控撤控
export const infoonoff = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/mg_disposition/info/on-off",
    method: "put",
    data: data
  });
};

// 导出
export const infodownload = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/mg_disposition/info/download",
    method: "post",
    responseType: "blob",
    // headers: { "Content-Type": "application/octet-stram" },
    data: data
  });
};

// 布控管理删除
export const dispositionDelete = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/mg_disposition/info",
    method: "delete",
    data: data
  });
};
// 布控求树tree
export const usertree = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/mg_disposition/wrap/user-tree",
    method: "post",
    data: data
  });
};
// 算法接口
export const algorithm = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/mg_disposition/wrap/algorithm",
    params: data
  });
};
// 获取布控维度
export const treenodes = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/mg_disposition/tree/nodes",
    params: data
  });
};

// 保存接口
export const dispositioninfo = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/mg_disposition/info",
    method: "post",
    data: data
  });
};

// 图片截取
export const featureall = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/vids/feature/all",
    method: "post",
    data: data
  });
};


export const objectlist = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/object_manage/other-object/list",
    method: "post",
    data: data
  });
};
//一键布控 车辆
export const dispositionCar = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/mg_disposition/disposition/car",
    method: "post",
    data: data
  });
};
//一键布控 人脸
export const dispositionFace = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/mg_disposition/disposition/face",
    method: "post",
    data: data
  });
};

//黑白名单库
export const classtab = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/mg_disposition/cms/classtab",
    method: "post",
    data: data
  });
};